import React from 'react';
import BreakTimeNew from '@src/components/BreakTimeNew';

const BreakTime = ({
  synthesisRequest,
  openSentences,
  isDisabledWhenOpenSentences,
  isDisabledWhenOffSentences,
  advanceFeature,
  newHandleChangeBreakTime,
  handleChangeBreakTime,
  handleCloseSearchBoxAndMoreMenu,
  handleCloseSearchBox,
}) => (
  <div className="group group-adjust-reading-style">
    <BreakTimeNew
      currentBreakTime={synthesisRequest.breakTime}
      disabled={
        openSentences ? isDisabledWhenOpenSentences : isDisabledWhenOffSentences
      }
      onChange={
        advanceFeature ? newHandleChangeBreakTime : handleChangeBreakTime
      }
      tooltipTitle="addBreakTimeV2"
      width="45px"
      handleCloseSearchBoxAndMoreMenu={handleCloseSearchBoxAndMoreMenu}
      handleCloseSearchBox={handleCloseSearchBox}
      newUiBreakTime
    />
  </div>
);

export default BreakTime;
